// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISetHideOfferInHistoryRequest,
  TSetHideOfferInHistoryModel,
  IMappers,
  TSetHideOfferInHistoryResponse,
  ISetHideOfferInHistoryResponse,
  ISetHideOfferInHistoryResponseError,
} from './types';

export const defaultConfig: TSetHideOfferInHistoryModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v1/set-hide-offer-in-history/',
} as TSetHideOfferInHistoryModel;

export function createSetHideOfferInHistoryModel(
  parameters: ISetHideOfferInHistoryRequest,
): TSetHideOfferInHistoryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISetHideOfferInHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISetHideOfferInHistoryRequest;
}

export async function fetchSetHideOfferInHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetHideOfferInHistoryOptions<TResponse200, TResponse400>): Promise<
  TSetHideOfferInHistoryResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSetHideOfferInHistoryModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetHideOfferInHistoryResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISetHideOfferInHistoryResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSetHideOfferInHistoryResponse;
}
